var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSelect',{attrs:{"options":_vm.statusOptions,"model-value":_vm.modelValue,"legend":_vm.$t('orderList.filters.status'),"exclude-default-option":""},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }